import React, { useCallback } from "react";
import PropTypes from "prop-types";

export const useAuthorization = () => {
  const {
    _rlapp_user: user,
    _rlapp_user: { permissions: userPermissions }
  } = window;

  if (!user) {
    throw Error("No user!");
  }
  const checkAccess = useCallback(
    allowedPermissions => {
      if (allowedPermissions?.length) {
        return allowedPermissions.some(permission =>
          userPermissions.includes(permission)
        );
      }
      return true;
    },
    [userPermissions]
  );

  return { checkAccess, userPermissions };
};

/**
 * Component used for restricting render for components based on permissions.
 * Example usage:
 *
 * <Authorization allowedPermissions=[permissions.VIEW_YARA]>
 *     <ExampleComponent />
 * </Authorization>
 *
 * @param allowedPermissions - list of allowed permissions that can see the component
 * @param forbiddenFallback - component used in case access is forbidden
 * @param children - components which's access is restricted based on allowed permissions
 */
const Authorization = ({
  allowedPermissions,
  forbiddenFallback = null,
  children
}) => {
  const { checkAccess } = useAuthorization();
  let accessGranted = false;

  if (allowedPermissions) {
    accessGranted = checkAccess(allowedPermissions);
  }
  return <>{accessGranted ? children : forbiddenFallback}</>;
};

Authorization.propTypes = {
  allowedPermissions: PropTypes.arrayOf(PropTypes.string),
  forbiddenFallback: PropTypes.node,
  children: PropTypes.node
};

export default Authorization;
